import {
  LEAD_BY_CAMPAING,
  LEAD_BY_CAMPAING_ERROR,
  CLEAN_LEAD_BY_CAMPAING,
  CLEAN_LEAD_BY_CAMPAING_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function leadByCampaignReducer(state = initialState, action) {
  switch (action.type) {
    case LEAD_BY_CAMPAING:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case LEAD_BY_CAMPAING_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_LEAD_BY_CAMPAING:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_LEAD_BY_CAMPAING_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
